export const SAVE_PROFILE_ERROR = 'Profile changed error!'
export const SAVE_PROFILE_SUCCESS = 'Profile changed successfully!'
export const DISCARD_PROFILE_ERROR = 'Discard error!'
